import React, { Component } from "react";
import { connect } from "react-redux";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import SurveyActions from "../SurveyActions";

class Survey extends Component {
  constructor(props){
    super(props);
    this.getAgeList = this.getAgeList.bind(this);
    this.handleAgeSelect = this.handleAgeSelect.bind(this);
    this.handleForm = this.handleForm.bind(this);
  }

  getAgeList(){
      let list = [];
      let i = 1;
      for(i = 14; i < 70; i++){
        list.push({value:i, label:i})
      }
      return list;
  }

  handleAgeSelect(option){
    this.props.setAge(option.value);
  }

  handleForm(e){
    this.props.setSurveyFormValue(e.target.name, e.target.value)
    this.props.countFormClicks()
  }

  componentDidMount() {

  }

  render() {
    return (
      <div>
        {
          this.props.displaySurvey.display ?
          <div className="" style={{textAlign:"left"}}>
            <div className="form-group">
              <p>{this.props.language.map.static.survey.text.p1}</p>
            </div>
            <div className="form-group">
              <p>{this.props.language.map.static.survey.questions.q7}</p>
              <div className="form-check">
                <label className="form-check-label">
                  <input
                      className="form-check-input"
                      type="checkbox"
                      name="tests"
                      value="1"
                      onChange={(e) => this.handleForm(e)}
                      checked={this.props.data.tests.indexOf("1") > -1}
                      translate="no"
                  />
                  &nbsp;
                  {this.props.language.map.labels.survey.testsAbci}
                </label>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <input
                      className="form-check-input"
                      type="checkbox"
                      name="tests"
                      value="2"
                      onChange={(e) => this.handleForm(e)}
                      checked={this.props.data.tests.indexOf("2") > -1}
                      translate="no"
                  />
                  &nbsp;
                  {this.props.language.map.labels.survey.testsOther}
                </label>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <input
                      className="form-check-input"
                      type="checkbox"
                      name="tests"
                      value="3"
                      onChange={(e) => this.handleForm(e)}
                      checked={this.props.data.tests.indexOf("3") > -1}
                      translate="no"
                  />
                  &nbsp;
                  {this.props.language.map.labels.survey.testsPersonality}
                </label>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <input
                      className="form-check-input"
                      type="checkbox"
                      name="tests"
                      value="4"
                      onChange={(e) => this.handleForm(e)}
                      checked={this.props.data.tests.indexOf("4") > -1}
                      translate="no"
                  />
                  &nbsp;
                  {this.props.language.map.labels.survey.testsNo}
                </label>
              </div>
            </div>
            <div className="form-group">
              <p>{this.props.language.map.static.survey.text.p2}</p>
              <textarea className="form-control" name="feedbackText" rows="8" onChange={(e) => this.handleForm(e)} value={this.props.data.feedbackText} translate="no"/>
            </div>
            <div className="form-group">
              <p className="alert alert-info">{this.props.language.map.static.survey.text.p4}</p>
            </div>
            <div className="form-group">
              <p>{this.props.language.map.static.survey.questions.q3}</p>
              <div className="form-check">
                <label className="form-check-label">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hasDegree"
                    onChange={(e) => this.handleForm(e)}
                    value="1"
                    checked={this.props.data.hasDegree === "1"}
                    translate="no"
                  />
                  &nbsp;
                  {this.props.language.map.labels.survey.yes}
                </label>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hasDegree"
                    onChange={(e) => this.handleForm(e)}
                    value="2"
                    checked={this.props.data.hasDegree === "2"}
                    translate="no"
                  />
                  &nbsp;
                  {this.props.language.map.labels.survey.no}
                </label>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hasDegree"
                    onChange={(e) => this.handleForm(e)}
                    value="3"
                    checked={this.props.data.hasDegree === "3"}
                    translate="no"
                  />
                  &nbsp;
                  {this.props.language.map.labels.survey.decline}
                </label>
              </div>
            </div>
            <div className="form-inline form-group">
              <label>{this.props.language.map.static.survey.questions.q4}&nbsp;&nbsp;</label>
              <input type="text" className="form-control" name="degree" onChange={(e) => this.handleForm(e)} value={this.props.data.degree}
                     disabled={this.props.data.hasDegree !== "1"} translate="no"/>
            </div>
            <div className="form-group">
              <p>{this.props.language.map.static.survey.questions.q5}</p>
              <div className="form-check">
                <label className="form-check-label">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="nativeLanguage"
                    onChange={(e) => this.handleForm(e)}
                    value="1"
                    checked={this.props.data.nativeLanguage === "1"}
                    translate="no"
                  />
                  &nbsp;
                  {this.props.language.map.labels.survey.yes}
                </label>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="nativeLanguage"
                    onChange={(e) => this.handleForm(e)}
                    value="2"
                    checked={this.props.data.nativeLanguage === "2"}
                    translate="no"
                  />
                  &nbsp;
                  {this.props.language.map.labels.survey.no}
                </label>
              </div>              <div className="form-check">
                <label className="form-check-label">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="nativeLanguage"
                    onChange={(e) => this.handleForm(e)}
                    value="3"
                    checked={this.props.data.nativeLanguage === "3"}
                    translate="no"
                  />
                  &nbsp;
                  {this.props.language.map.labels.survey.decline}
                </label>
              </div>
            </div>
               <div className="form-inline form-group">
               <label>{this.props.language.map.static.survey.questions.q6}&nbsp;&nbsp;</label>
               <input type="text" className="form-control" name="language" onChange={(e) => this.handleForm(e)}
                      value={this.props.data.language}
                      disabled={this.props.data.nativeLanguage !== "2"}
                      translate="no"
               />
              </div>
            <div className="form-group">
              {this.props.language.map.static.survey.questions.q2}
              &nbsp;
              &nbsp;
              <span>
                <div className="form-check form-check-inline">
                  <label className="form-check-label">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="gender"
                        onChange={(e) => this.handleForm(e)}
                        value="1"
                        checked={this.props.data.gender === "1"}
                        translate="no"
                    />
                    &nbsp;
                    {this.props.language.map.labels.survey.genderMale}
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <label className="form-check-label">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="gender"
                        onChange={(e) => this.handleForm(e)}
                        value="2"
                        checked={this.props.data.gender === "2"}
                        translate="no"
                    />
                    &nbsp;
                    {this.props.language.map.labels.survey.genderFemale}
                  </label>
                </div>
                <div className="form-check-inline">
                  <label>
                    {this.props.language.map.labels.survey.genderAux}&nbsp;&nbsp;
                  </label>
                  <input className="form-control" type="text" name="gender" onChange={(e) => this.handleForm({
                    target:{
                      name: "gender",
                      value: "3"
                    }
                  })} translate="no"
                  />
                </div>
              </span>
            </div>
            <div className="form-inline form-group">
              <label>{this.props.language.map.static.survey.questions.q1}</label>
              &nbsp;
              <div className="col-xl-12 col-lg-10 col-md-8 col-xm-6 col-xs-4">
                <Select
                    value={this.props.data.age}
                    onChange={(option) => this.handleForm({
                      target:{
                        name:"age",
                        value: option.value
                      }
                    })}
                    options={this.getAgeList()}
                    translate="no"
                />
              </div>
            </div>
            <div className="form-group" style={{textAlign:"center"}}>
              <button className="btn btn-outline-primary" onClick={(e) => this.props.saveSurvey(e)} translate="no">{this.props.language.map.labels.survey.send}</button>
            </div>
          </div>
          :
          null
        }
        {
          this.props.displayThanks.thanks ?
          <div>
            <p>{
              this.props.language.map.static.survey.text.p3
            }</p>
            <p>{this.props.language.map.static.survey.text.p5}<br/>{this.props.language.map.static.survey.text.p6}</p>
            <p></p>
          </div>
          :
          null
        }
      </div>
    );
  }
}
const mapStateToProps = state => ({
  language: state.application.language,
  data: state.survey.data,
  displaySurvey: state.survey.displaySurvey,
  displayThanks: state.survey.displayThanks
});
const mapDispatchToProps = dispatch => ({
  setAge:(age) => dispatch(SurveyActions.setAge(age)),
  setGender:(gender) => dispatch(SurveyActions.setGender(gender)),
  setHasDegree:(boolean) => dispatch(SurveyActions.setHasDegree(boolean)),
  setDegree:(degree) => dispatch(SurveyActions.setDegree(degree)),
  setLanguageNative:(boolean) => dispatch(SurveyActions.setLanguageNative(boolean)),
  setLanguage:(language) => dispatch(SurveyActions.setLanguage(language)),
  setTests:(tests) => dispatch(SurveyActions.setTests(tests)),
  setFeedbackText:(test) => dispatch(SurveyActions.setFeedbackText(test)),
  saveSurvey:(e) => dispatch(SurveyActions.saveSurvey(e)),
  setSurveyFormValue: (component, value) => dispatch(SurveyActions.setSurveyFormValue(component, value)),
  countFormClicks: () => dispatch(SurveyActions.countFormClicks())
});

export default connect(mapStateToProps, mapDispatchToProps)(Survey);



// WEBPACK FOOTER //
// ./src/modules/survey/view/Survey.js